import React from "react";
import {Link} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../style/home.css';
import axios from "axios";
import Swal from "sweetalert2";


class Wallet extends React.Component {

    constructor() {
        super();
        this.state = {
            wallet: "",
            history:[]
        }
    }

    componentDidMount() {


        var form = new FormData();
        form.append("session", localStorage.getItem("token"));
        form.append("mobile", localStorage.getItem("mobile"));

        axios
            .post(process.env.REACT_APP_URL+"/api2/transaction_history.php", form,
            )
            .then((response) => {
                if(response.status === 200){
                    if (response.data.nosession){
                        Swal.fire({
                            toast: true,
                            title: 'Oops...',
                            text: "Session Expired"
                        }).then((e)=>{
                            localStorage.clear()
                            window.location.href = "/login";
                        })
                    }
                    localStorage.setItem("wallet", response.data.wallet)
                    this.setState({
                        wallet:response.data.wallet,
                        history:response.data.data
                    })
                } else if(response.status === 401){
                    //  navigate("/login")
                }
            })
    }


    render() {


        return (<>
                <div className="RootView">
                    <div className="RootWidth">

                        <div className="loginDiv">


                            <div className="toolbar">
                                <div>
                                    <img onClick={()=>{window.history.go(-1)}}  src="../images/back.png" style={{padding: "5px"}}/>
                                    <span>Passbook</span>
                                </div>
                            </div>

                            <div className="passbook">

                                <div className="passbook_head">
                                    <span style={{width: "110px"}}>Date</span>
                                    <span style={{width: "150px"}}>Particulars</span>
                                    <span style={{width: "150px"}}>Previous</span>
                                    <span style={{width: "150px"}}>Transaction</span>
                                    <span style={{width: "150px"}}>Current</span>
                                </div>

                                
                                { this.state.history && this.state.history.map((result) => {
                                        return (
                                            <div className="passbook_item"  key={result.sn}>
                                                <span style={{width: "110px"}}>{result.date}</span>
                                                <span style={{width: "150px"}}>{result.remark}</span>
                                                <span style={{width: "150px"}}>{result.before_wallet}</span>
                                                <span style={{width: "150px"}}>{result.amount}</span>
                                                <span style={{width: "150px"}}>{result.after_wallet}</span>
                                            </div>
                                        )})}
                                </div>



                            </div>


                    </div>
                </div>


            </>
        );
    }

}

export default Wallet;
